<template>
  <b-card header="Ranking de Comissões" class="mb-3">
    <b-alert v-if="items.length === 0" show variant="secondary">
      Nenhuma comissão registrada no período selecionado
    </b-alert>

    <div v-else>
      <div class="d-md-none">
        <b-card
          v-for="(item, index) in items"
          :key="item.userStoreId"
          class="mb-2"
        >
          <div class="d-flex justify-content-between align-items-center">
            <strong>{{ index + 1 }}º {{ item.userName }}</strong>
            <b-badge variant="primary">{{ item.totalSales }} vendas</b-badge>
          </div>
          <div class="mt-2 small">
            <div>Faturamento: {{ formatCurrency(item.totalAmount) }}</div>
            <div>Ticket médio: {{ formatCurrency(item.averageTicket) }}</div>
            <div>
              Tempo médio: {{ formatMinutes(item.averagePeriodMinutes) }}
            </div>
          </div>
        </b-card>
      </div>

      <b-table
        class="d-none d-md-table"
        responsive
        striped
        hover
        :items="tableItems"
        :fields="fields"
      />
    </div>
  </b-card>
</template>

<script>
import { formatCurrency } from '@/helpers/numbers'

export default {
  name: 'CommissionsRanking',
  props: {
    report: {
      type: Object,
      default: () => ({ data: { summary: [] } })
    }
  },
  data() {
    return {
      fields: [
        { key: 'position', label: '#' },
        { key: 'userName', label: 'Funcionário' },
        { key: 'totalSales', label: 'Vendas Efetivas' },
        { key: 'totalAmount', label: 'Faturamento' },
        { key: 'averageTicket', label: 'Ticket médio' },
        { key: 'averagePeriodMinutes', label: 'Tempo médio' }
      ]
    }
  },
  computed: {
    items() {
      const summary = this.report?.data?.summary || []
      return [...summary].sort(
        (a, b) => Number(b.totalSales || 0) - Number(a.totalSales || 0)
      )
    },
    tableItems() {
      return this.items.map((item, index) => ({
        ...item,
        position: index + 1,
        totalAmount: this.formatCurrency(item.totalAmount),
        averageTicket: this.formatCurrency(item.averageTicket),
        averagePeriodMinutes: this.formatMinutes(item.averagePeriodMinutes)
      }))
    }
  },
  methods: {
    formatCurrency,
    formatMinutes(value) {
      const minutes = Math.round(Number(value || 0))
      const hours = Math.floor(minutes / 60)
      const remainingMinutes = minutes % 60

      if (hours > 0) {
        return `${hours}h ${remainingMinutes}min`
      }

      return `${remainingMinutes}min`
    }
  }
}
</script>
